import { Create } from "react-admin"
import FormInput from "./FormInput"


function CustomerCreate() {

  return (
    <Create redirect='list'>
      <FormInput />
    </Create>
  )
}

export default CustomerCreate